<template>
  <div>
    <v-row dense class="no-print">
      <v-col cols="12" sm="4" md="3">
        <v-text-field
          v-model="formData.dari"
          type="date"
          label="Dari Tanggal"
          outlined
          dense
          hide-details
          @keydown.enter="fetchLaporan"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="3">
        <v-text-field
          v-model="formData.sampai"
          type="date"
          label="Sampai Tanggal"
          outlined
          dense
          hide-details
          @keydown.enter="fetchLaporan"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="3">
        <v-btn color="primary" :loading="state.loading" @click="fetchLaporan">
          Tampilkan
        </v-btn>
      </v-col>
    </v-row>
    <v-checkbox
      v-model="formData.hanya_selesai"
      label="Hanya tampilkan data yang masuk pelaporan pajak"
      hide-details
      dense
      class="mb-2 no-print"
    ></v-checkbox>

    <h3 class="no-print">Preview</h3>
    <p v-if="state.noData && !state.loading">No Data</p>

    <v-progress-linear
      v-if="state.loading"
      indeterminate
      rounded
      height="6"
    ></v-progress-linear>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="d-flex">
        <h1 class="report-title-light mr-5">
          {{ portAwal ? portAwal.text + " - " : "" }}LAPORAN PENGELUARAN KAS
        </h1>
        <div class="border">
          <h2 class="report-title-light">
            {{ formatDate(formData.dari) }} s/d {{ formatDate(formData.sampai) }}
          </h2>
        </div>
      </div>

      <table class="w-100 mt-3">
        <thead>
          <tr>
            <th width="9%">Tanggal</th>
            <th width="9%">Kategori</th>
            <th width="9%">POS</th>
            <th width="12%">Oleh</th>
            <th width="31%">Keperluan</th>
            <th width="15%">Rp</th>
            <th width="12%">ACC</th>
            <th width="5%" class="no-print">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.id">
            <td class="text-center">{{ formatDate(item.tgl) }}</td>
            <td class="text-center">{{ item.kategori }}</td>
            <td class="text-center">{{ item.pos }}</td>
            <td class="text-center">{{ namaUser(item.oleh) }}</td>
            <td>{{ item.keperluan }}</td>
            <td class="text-right">
              Rp. {{ formatCurrency(Math.abs(item.nominal)) }}
            </td>
            <td class="text-center">{{ namaUser(item.acc) }}</td>
            <td class="text-center no-print">
              <v-btn icon x-small color="primary" @click="openEdit(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="text-right"><b>Total:</b></td>
            <td class="text-right">
              <b>Rp. {{ formatCurrency(total) }}</b>
            </td>
            <td></td>
            <td class="no-print"></td>
          </tr>
        </tbody>
      </table>
    </main>

    <!-- Dialog Edit -->
    <v-dialog v-model="edit.open" max-width="720" persistent>
      <v-card>
        <v-card-title>
          Edit Pengeluaran Kas
          <span class="text-subtitle-1 ml-2">(No Kas: {{ edit.form.id }})</span>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="edit.form.tgl"
                type="date"
                label="Tanggal"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="edit.form.kategori"
                :items="items.kategori"
                label="Kategori"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="edit.form.pos"
                :items="posItems"
                label="POS Pengeluaran"
                outlined
                dense
                clearable
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="editJumlah"
                label="Jumlah"
                prefix="Rp"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="edit.form.oleh"
                :items="items.karyawan"
                label="Oleh"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="edit.form.acc"
                :items="items.karyawan"
                label="ACC"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="edit.form.keperluan"
                label="Untuk Keperluan"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="edit.form.selesai"
                label="Selesai (Masuk Pelaporan Pajak)"
                hide-details
                dense
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="edit.saving" @click="edit.open = false">
            Batal
          </v-btn>
          <v-btn color="primary" :loading="edit.saving" @click="saveEdit">
            Simpan Perubahan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn
      class="mx-2 no-print"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

function toISODate(date) {
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}/.test(date)) {
    return date.substr(0, 10);
  }
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")}`;
}

export default {
  data() {
    const today = new Date().toISOString().substr(0, 10);

    return {
      portAwal: JSON.parse(localStorage.getItem("port_awal")),
      posItems: ["DECLARING", "JKT PTK", "PTK JKT", "KANTOR"],
      state: {
        loading: false,
        noData: true
      },
      formData: {
        dari: today,
        sampai: today,
        hanya_selesai: true
      },
      items: {
        kategori: [],
        karyawan: []
      },
      data: [],
      edit: {
        open: false,
        saving: false,
        form: {}
      }
    };
  },
  computed: {
    total() {
      return this.data.reduce((a, b) => a + Math.abs(b.nominal), 0);
    },
    editJumlah: {
      get() {
        return this.formatCurrency(this.edit.form.jumlah || 0);
      },
      set(val) {
        this.edit.form.jumlah = this.convertToAngka(val);
      }
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      if (!this.formData.dari || !this.formData.sampai) {
        alert("Tanggal harus diisi");
        return;
      }

      this.state.loading = true;

      await axios
        .get("kas/laporan-pengeluaran-kas", {
          params: {
            dari: this.formData.dari,
            sampai: this.formData.sampai,
            hanya_selesai: this.formData.hanya_selesai ? 1 : 0
          }
        })
        .then(res => {
          this.data = res.data;
          this.state.noData = !this.data.length;
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    async fetchKategori() {
      try {
        const res = await axios.get("master-data?kategori=kategori_pengeluaran");
        this.items.kategori = (res.data || []).map(d => d.nama);
      } catch (err) {
        // ignore
      }
    },
    async fetchKaryawan() {
      try {
        const res = await axios.get("karyawan");
        this.items.karyawan = (res.data || []).map(item => ({
          text: item.nama,
          value: item.user_id
        }));
      } catch (err) {
        // ignore
      }
    },
    userId(val) {
      if (val && typeof val === "object") return val.user_id;
      return val ? parseInt(val) : null;
    },
    namaUser(val) {
      if (val && typeof val === "object") return val.nama || "";
      const found = this.items.karyawan.find(k => k.value == val);
      return found ? found.text : "";
    },
    isSelesai(item) {
      const v = item.selesai;
      return v === null || v === undefined || v === true || v == 1;
    },
    openEdit(item) {
      if (item.kategori && !this.items.kategori.includes(item.kategori)) {
        this.items.kategori.push(item.kategori);
      }

      this.edit.form = {
        id: item.id,
        tgl: toISODate(item.tgl),
        kategori: item.kategori,
        pos: item.pos ? item.pos.toUpperCase() : null,
        oleh: this.userId(item.oleh),
        acc: this.userId(item.acc),
        jumlah: Math.abs(Number(item.nominal) || 0),
        keperluan: item.keperluan,
        selesai: this.isSelesai(item),
        kc: item.kc || null,
        kv: item.kv || null
      };
      this.edit.open = true;
    },
    async saveEdit() {
      const f = this.edit.form;
      if (!f.tgl || !f.kategori || !f.oleh || !f.acc || !f.keperluan) {
        alert("Tanggal, Kategori, Oleh, ACC dan Keperluan wajib diisi");
        return;
      }
      if (!f.jumlah || f.jumlah <= 0) {
        alert("Jumlah harus lebih dari 0");
        return;
      }

      this.edit.saving = true;
      try {
        await axios.put(`kas/biaya-lain/${f.id}`, {
          jenis_kas: "keluar",
          tgl: f.tgl,
          kategori: f.kategori,
          pos: f.pos || "",
          oleh: f.oleh,
          acc: f.acc,
          jumlah: f.jumlah,
          keperluan: f.keperluan,
          selesai: f.selesai,
          kc: f.kc,
          kv: f.kv
        });
        this.edit.open = false;
        await this.fetchLaporan();
      } catch (err) {
        alert(err.response?.data?.message || "Gagal menyimpan perubahan");
      } finally {
        this.edit.saving = false;
      }
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai === null || nilai === undefined) return 0;
      const str = String(nilai);
      if (str === "" || str === "0") return 0;
      const [angka, desimal] = str.split(",");
      const bulat = angka.replace(/[^\d]/g, "");
      const hasil = parseFloat(desimal ? `${bulat}.${desimal}` : bulat);
      return Number.isNaN(hasil) ? 0 : hasil;
    }
  },
  created() {
    this.fetchKategori();
    this.fetchKaryawan();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report-title-light {
  font-weight: 400;
  text-decoration: underline;
}

.border {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 1px solid black;
  line-height: 1;
  padding: 0 5px;
}

.border h2 {
  text-decoration: none;
}

table {
  border-collapse: collapse;
}

table th,
table td {
  font-size: 12px !important;
  border: 1px solid gray !important;
  padding: 2px 4px;
}

th {
  font-weight: bold !important;
  background-color: #f5f5f5;
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>
